<div class="email-container">
  <mat-form-field class="field-input" appearance="outline">
    <mat-label>Please enter email address.</mat-label>
    <input
      matInput
      ngModel
      #emailIdInput="ngModel"
      placeholder="Please enter email address"
      [(ngModel)]="emailId"
    />
  </mat-form-field>
</div>
